export default __webpack_public_path__ + "static/media/CN.7c19410a.svg";